import { render } from "./updateSingle.vue?vue&type=template&id=97d85494&scoped=true"
import script from "./updateSingle.vue?vue&type=script&lang=js"
export * from "./updateSingle.vue?vue&type=script&lang=js"

import "./updateSingle.vue?vue&type=style&index=0&id=97d85494&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-97d85494"

export default script